import type { Messages } from './en';

/** Textos de la fase D (aula). `phrases` i `contest.words` són pràctica d’anglès i es queden en anglès. */
export const caClassroom: Pick<Messages, 'classroom'> = {
  classroom: {
    mapNames: {},
    zones: {},
    objects: {
      cls_lostBox: 'Caixa d’objectes perduts',
      cls_notice: 'Tauler d’anuncis',
      cls_ball: 'Pilota del pati',
    },
    npc: {
      xiaohua: 'Xiaohua',
      xiaomei: 'Xiaomei',
      azhe: 'Azhe',
      xiaoqiang: 'Xiaoqiang',
      xiaofang: 'Xiaofang',
    },
    items: {},

    /** PRÀCTICA D’ANGLÈS: es queda en anglès. */
    phrases: {
      late: 'Sorry I’m late. It won’t happen again.',
      homework: 'Excuse me, could you help me? I don’t understand this part.',
      standing: 'I’m sorry for talking. I’ll raise my hand next time.',
      ball: 'I feel sad when I don’t get a turn.',
      forgotHomework: 'I’m sorry, I forgot my homework. I’ll bring it next time.',
      misunderstanding: 'Excuse me, I think there’s a misunderstanding.',
      bullying: 'Stop, please. That’s not kind.',
      contest: 'Could you repeat the word, please?',
    },

    ui: {
      sayIt: '🔊 Digues-ho en anglès',
      practised: '🗣️ Frase en anglès practicada!',
      journalMenu: '📔 Diari de creixement',
      journalTitle: '📔 Diari de creixement',
      tabPeople: 'Amics i família',
      tabLog: 'Moments',
      tabHobbies: 'Aficions',
      family: 'Família',
      classmates: 'Companys i amics',
      noLog: 'Encara no hi ha res escrit. Surt a viure els teus dies: les decisions amables, els moments valents i fins i tot els errors acaben aquí.',
      noHobbies: 'Encara no has practicat cap afició. Prova el piano, el cavallet, el camp o la biblioteca!',
      hobbyLevel: (n: number) => `Nv ${n}`,
      hobbyPoints: (n: number) => `${n} sessions`,
      dayLabel: (week: number, day: string) => `Setmana ${week} · ${day}`,
      todayRow: 'Moments d’avui',
      noticeTitle: '📌 Tauler d’anuncis',
      noticeNone: 'Avui no hi ha res especial. Que tinguis un gran dia a l’escola!',
      noticeCases: 'Potser avui algun company necessita un amic. Estigues atent!',
      lateGone: 'En Xiaohua ja ha entrat. Encara pots ser amable amb ell més tard.',
      later: 'En parlem després',
      back: '‹ Tornar',
      tryAgain: 'Mmm, prova-ho d’una altra manera.',
      narrator: 'Mentrestant…',
      ballIdle: 'Una pilota de futbol gastada amb «小強» escrit amb retolador. Segur que en Xiaoqiang se l’ha deixada aquí.',
      chat: '💬 Xerrar',
      giveBack: (what: string) => `🎁 Tornar ${what}`,
      coolHello: ['Ah… hola.', 'Mm. Hola.', '…Hola.'],
      warmHello: ['Ei, millor amic!', 'Visca, ets tu!', 'Ja ets aquí! Tenia ganes de veure’t.'],
    },

    love: ['Desconeguts', 'Coneixent-nos', 'Amics', 'Bons amics', 'Millors amics'],
    loveFamily: ['Distants', 'Bé', 'Units', 'Molt units', 'Inseparables'],

    hobbies: {
      music: '🎵 Música', art: '🎨 Art', sport: '⚽ Esport', reading: '📚 Lectura', nature: '🌿 Natura', craft: '✂️ Manualitats',
      cooking: '🍳 Cuina', garden: '🌱 Jardineria', english: '🗣️ Anglès', dance: '💃 Ball',
    },

    journalKeys: {
      helpedLate: () => 'Vaig ajudar en Xiaohua a demanar perdó per arribar tard… i li vaig donar un truc amb el despertador',
      lateExcuse: () => 'Vaig dir a en Xiaohua que s’inventés una excusa. No va sortir bé.',
      teasedLate: () => 'Em vaig riure d’en Xiaohua quan va arribar tard',
      helpedHomework: () => 'Vaig ajudar la Xiaomei a demanar ajuda a la mestra, amb sinceritat',
      copiedHomework: () => 'Vaig deixar que la Xiaomei copiés els meus deures. Continuava sense entendre’ls.',
      skippedHomework: () => 'Vaig dir a la Xiaomei que fes veure que estava malalta',
      helpedStanding: () => 'Vaig ajudar l’Azhe a calmar-se i a arreglar-ho amb la senyora Lin',
      clowned: () => 'Vaig fer ganyotes amb l’Azhe a classe i ens van renyar tots dos',
      mockedStanding: () => 'Vaig dir «t’ho mereixes» a l’Azhe',
      ballMadeUp: () => 'Vaig ajudar en Xiaoqiang i la Xiaofang a fer servir frases amb «Em sento…» i a fer torns',
      ballSide: (who?: string) => `Em vaig posar del costat de ${who ?? 'un dels dos'} en la baralla per la pilota`,
      ballGrabbed: () => 'Vaig agafar la pilota i vaig fugir corrents. Ningú no va riure.',
      madeUp: (who?: string) => `Vaig demanar perdó a ${who ?? 'un amic'} i vam fer les paus`,
      forgotHonest: () => 'Em vaig descuidar els deures i vaig dir la veritat a la mestra',
      forgotExcuse: () => 'Em vaig descuidar els deures i em vaig inventar una excusa',
      homeworkMadeUp: () => 'Vaig fer a l’esbarjo els deures que em faltaven',
      lostFound: () => 'Vaig perdre l’estoig… i el vaig trobar a la caixa d’objectes perduts',
      returnedItem: (who?: string) => `Vaig tornar a ${who ?? 'un company'} una cosa que havia perdut`,
      calmExplained: () => 'Vaig explicar amb calma un malentès a la senyora Lin',
      shouted: () => 'Vaig cridar a la senyora Lin per un malentès',
      bullyStood: () => 'Em vaig quedar al costat d’en Bo quan uns grans se’n reien',
      bullyTold: () => 'Vaig avisar un adult quan es reien d’en Bo',
      bullyIgnored: () => 'Me’n vaig anar quan es reien d’en Bo',
      contestWin: () => 'Vaig guanyar el concurs de lletrejar de la classe!',
      contestSetback: () => 'No vaig guanyar el concurs de lletrejar… encara. Continuaré practicant.',
      quiz: (grade?: string) => `Examen sorpresa: nota ${grade ?? '?'}`,
      meeting: (how?: string) => (how === 'great' ? 'Reunió de pares: la senyora Lin va dir coses precioses de mi' : how === 'mixed' ? 'Reunió de pares: algunes bones notícies i algunes coses per millorar' : 'Reunió de pares: la mama i jo vam fer un pla junts'),
    },

    kids: {
      xiaohua: {
        hello: ['Hola! Arribo tard? …Uf, sort. Ni tan sols és l’hora de classe.', 'Ei! Has dormit bé? Jo sempre dormo massa bé.'],
        topics: [
          { say: 'El meu avi diu que qui matina fa farina. Jo dic que qui matina té molta son.', choices: [{ t: 'Ha, ha! I si et fiques al llit abans?', reply: 'Mmm… potser si deixo de llegir còmics sota la manta.' }, { t: 'Què t’agrada llegir?', reply: 'Còmics de gats espacials! La capitana és una gata que es diu Mochi.' }] },
          { say: 'Estic estalviant per a un kit de coet. Té una plataforma de llançament de veritat!', choices: [{ t: 'Que guai! M’ho ensenyes quan el muntis?', reply: 'Sí! Tu pots fer el compte enrere: tres, dos, u…' }, { t: 'Quant et falta?', reply: 'Dues setmanes més sense comprar llaminadures. Uf.' }] },
        ],
        react: {
          alarm: 'Saps què? Ahir a la nit vaig posar dues alarmes i vaig preparar la motxilla. Avui he arribat D’HORA! Gràcies pel truc!',
          excuse: 'L’excusa no va funcionar… la senyora Lin ho sabia. La propera vegada diré la veritat i prou.',
          teased: '…Ah. Ets tu. Si us plau, no te’n tornis a riure de mi. Em va fer sentir molt petit.',
          madeUp: 'Ja estem bé. Gràcies per demanar-me perdó: has estat genial.',
        },
        apologise: 'Demanar-li perdó per haver-te’n rigut',
        apologyReply: 'D’acord… gràcies. Ja està bé. Vols veure el meu còmic de gats espacials?',
      },
      xiaomei: {
        hello: ['Oh! Hola… estava llegint.', 'Hola. A tu també t’agrada la biblioteca?'],
        topics: [
          { say: 'He acabat un llibre sobre una nena que parla amb les balenes. Vaig plorar al final. És estrany?', choices: [{ t: 'Gens estrany. Els bons llibres fan això.', reply: 'Gràcies… te’l deixo si vols.' }, { t: 'Les balenes de veritat poden «parlar»!', reply: 'De debò? Canten cançons que arriben molt lluny. Això també ho vaig llegir!' }] },
          { say: 'Estic intentant ser més valenta. Avui he dit «bon dia» al conductor de l’autobús.', choices: [{ t: 'Que valenta! Els passets petits compten.', reply: 'M’ha dit bon dia ell també! M’he posat molt contenta.' }, { t: 'La propera vegada, digues-ho en anglès!', reply: 'Good… morning! Hi, hi. Ho he aconseguit.' }] },
        ],
        react: {
          asked: 'La senyora Lin em va ajudar amb l’exercici 3. Ara l’entenc! Preguntar feia por… però va valer la pena.',
          copied: 'Continuo sense entendre l’exercici 3… Copiar no em va ajudar a aprendre. La propera vegada m’ho expliques?',
          skipped: 'Em vaig amagar a la infermeria, però no estava malalta. Em vaig sentir pitjor, no millor.',
          madeUp: 'Gràcies per demanar-me perdó. Estudiem junts algun dia?',
        },
        apologise: 'Demanar-li perdó pel mal consell',
        apologyReply: 'No passa res. Tots dos hem après alguna cosa. Fem els deures junts la propera vegada?',
      },
      azhe: {
        hello: ['Ei! Vols sentir un acudit? …Després. Estic practicant l’autocontrol. He, he.', 'Ei, ei! Què hi ha?'],
        topics: [
          { say: 'Per què es va menjar l’alumne els deures? Perquè la mestra va dir que eren bufar i fer ampolles!', choices: [{ t: 'Ha, ha! És dolentíssim. M’encanta.', reply: 'En tinc cent més. Me’ls guardo per a l’esbarjo!' }, { t: 'Explica’n un altre!', reply: 'Què té quatre rodes i mosques? Un camió de les escombraries! Ha, ha, ha!' }] },
          { say: 'De gran vull ser presentador de la tele. Parlar és el meu superpoder!', choices: [{ t: 'Ho faries genial!', reply: 'Oi que sí? Però un bon presentador també sap quan ha d’escoltar. Aquesta part l’estic aprenent.' }, { t: 'Però els superpoders s’han de controlar.', reply: 'Ha, això diu la senyora Lin. Hauríeu de muntar un club.' }] },
        ],
        react: {
          calm: 'Avui he aixecat la mà tres vegades i he esperat cada cop. La senyora Lin m’ha donat un adhesiu!',
          clowned: 'Ahir ens vam ficar tots dos en un embolic, eh? Millor guardem les ganyotes per a l’esbarjo.',
          mocked: 'Hmpf. Allò de «t’ho mereixes» no va estar gens bé, saps?',
          madeUp: 'Tot bé, amic! Tothom diu bestieses de vegades. Jo el primer!',
        },
        apologise: 'Demanar-li perdó per haver estat antipàtic',
        apologyReply: 'Disculpes acceptades! Piquem de mans? ✋',
      },
      xiaoqiang: {
        hello: ['Ei! Juguem a pilota a l’esbarjo?', 'Ei! Ahir vaig marcar tres gols al camp!'],
        topics: [
          { say: 'Seré futbolista professional. Tot i que l’entrenador diu que he de passar més.', choices: [{ t: 'Passar fa millor tot l’equip!', reply: 'Sí, sí… hi estic treballant. La Xiaofang passa molt bé, de fet.' }, { t: 'M’ensenyes un truc?', reply: 'És clar! Trepitges la pilota, la tires enrere i et gires. Fàcil!' }] },
          { say: 'El meu pare i jo mirem beisbol cada diumenge. Crida a la tele. És superdivertit.', choices: [{ t: 'Quin és el teu equip preferit?', reply: 'Els Brothers! Groc per sempre!' }, { t: 'I la tele li crida a ell?', reply: 'Ha, ha! No, però la meva mare sí!' }] },
        ],
        react: {
          madeUp: 'La Xiaofang i jo ara fem torns. Cinc minuts cadascú. Sincerament? És més divertit entre dos.',
          sideMe: 'Gràcies per posar-te del meu costat ahir… però ara la Xiaofang no em parla. És un rotllo.',
          sideOther: 'Ahir et vas posar del costat de la Xiaofang. Encara estic molest.',
          grabbed: 'No mola fugir corrents amb la meva pilota. No és una joguina per fer enrabiar.',
          madeUpYou: 'D’acord, tornem a estar bé. Gràcies per demanar perdó.',
        },
        apologise: 'Demanar perdó i parlar-ne',
        apologyReply: 'D’acord. Suposo que jo tampoc no ho vaig fer gaire bé. La propera vegada juguem tots junts.',
      },
      xiaofang: {
        hello: ['Hola! Has vist els núvols aquest matí? N’hi havia un que semblava un conill.', 'Ei! Estic practicant els tirs lliures. Vols mirar?'],
        topics: [
          { say: 'Hi ha gent que diu que el futbol és cosa de nois. Quina bestiesa. A la pilota li és igual qui la xuta.', choices: [{ t: 'Totalment! Jugues molt bé.', reply: 'Gràcies! Practico cada matí abans d’anar a l’escola.' }, { t: 'A veure si juguem junts algun dia!', reply: 'Tracte fet! T’ensenyo el meu xut amb efecte.' }] },
          { say: 'Quan m’enfado, compto fins a deu i estrenyo els punys. Després els deixo anar. Funciona… gairebé sempre.', choices: [{ t: 'És un truc genial.', reply: 'Me’l va ensenyar la meva germana gran. Diu que els sentiments són com les onades: passen.' }, { t: 'Jo respiro fondo.', reply: 'Oh, això també ho provaré. Endins… i enfora.' }] },
        ],
        react: {
          madeUp: 'Fer torns és moltíssim millor que barallar-se. I en Xiaoqiang em va demanar perdó! Això no passa mai!',
          sideMe: 'Gràcies per defensar-me. Però… la propera vegada potser podries ajudar-nos a tots dos, d’acord?',
          sideOther: 'Et vas posar del costat d’en Xiaoqiang. De veritat que em pensava que eres el meu amic.',
          grabbed: 'Això no va fer gens de gràcia. Ja estàvem disgustats.',
          madeUpYou: 'Gràcies per demanar perdó. Tornem a ser amics!',
        },
        apologise: 'Demanar perdó i parlar-ne',
        apologyReply: 'D’acord. Gràcies per tornar a dir-m’ho. Això té mèrit.',
      },
    },

    react: {
      teacher: {
        honest: 'Gràcies una altra vegada per dir-me la veritat sobre els deures. La sinceritat ho fa tot més fàcil.',
        calm: 'Encara em sap greu el malentès de l’altre dia. M’ho vas explicar amb tanta calma que vaig aprendre de tu.',
        helped: 'M’he fixat en com ajudes els teus companys. Això és el que fa un bon amic.',
      },
      bo: {
        stood: 'Gràcies per quedar-te al meu costat al parc. Ara, quan veig aquells nens, em sento més valent.',
        told: 'L’oncle Chun va parlar amb aquells nens grans. Em van demanar perdó! Gràcies per avisar-lo.',
        ignored: 'Vaig veure que te n’anaves al parc… No passa res. Només que… la propera vegada, et quedes amb mi?',
      },
      mom: {
        meeting: 'Encara somric quan penso en el que va dir la senyora Lin a la reunió de pares.',
      },
      festival: (name: string) => `Bon ${name}! Oi que aquesta setmana és divertida?`,
      trip: (place: string) => `M’han dit que vas anar a ${place}! Què és el que més et va agradar?`,
      typhoon: 'Quin tifó! Queda’t a casa i vés amb compte, d’acord?',
      rain: 'Quanta pluja avui! Has portat paraigua?',
    },

    cases: {
      late: {
        open: 'Ai, no, ai, no! M’he adormit i ja ha sonat el timbre! La senyora Lin s’enfadarà moltíssim… I si m’amago al lavabo fins a l’esbarjo?',
        good: 'Amagar-te ho empitjora. Entrem i demanem perdó junts.',
        excuse: 'Digues-li que l’autobús ha arribat tard.',
        tease: 'Ha, ha! Arribes SUPERTARD!',
        how: 'Però… què li dic?',
        howGood: 'Demana perdó, digues la veritat i promet que t’hi esforçaràs més.',
        howQuiet: 'Entra sense fer soroll. Potser no se n’adona.',
        quietReply: 'Colar-me em fa por… I si em veu? Crec que és millor dir-li-ho.',
        phraseIntro: 'Practiquem-ho junts, en anglès, com ens va ensenyar la senyora Lin:',
        plan: 'D’acord, li ho diré! Però com ho faig per no arribar tard la propera vegada?',
        planAlarm: 'Posa una alarma i deixa el rellotge lluny del llit.',
        planBag: 'Prepara la motxilla la nit abans.',
        planBoth: 'Les dues coses! Una alarma I la motxilla a punt al costat de la porta.',
        planReply: 'És un pla genial. Ho provaré aquesta nit!',
        teacher: 'Gràcies per dir-m’ho amb sinceritat, Xiaohua. Tothom arriba tard alguna vegada; el que importa és el que fem després. Vine a seure.',
        thanks: 'Uf… No n’hi ha hagut per a tant. Gràcies per ajudar-me!',
        excuseEnd: 'En Xiaohua diu a la senyora Lin que l’autobús ha arribat tard. Ella li respon amb calma que va veure arribar el seu autobús a l’hora. Ara ho ha d’explicar dues vegades… Les excuses solen complicar les coses.',
        teaseEnd: 'En Xiaohua mira a terra i entra sol. Té les orelles vermellíssimes. Com et sentiries tu?',
      },
      homework: {
        open: 'Jo… no he acabat els deures de mates. No entenia l’exercici 3, així que… ho vaig deixar. Si entro, tothom ho veurà.',
        good: 'No passa res per no entendre-ho. Anem a demanar ajuda a la senyora Lin, amb sinceritat.',
        copy: 'Ràpid, copia els meus!',
        sick: 'Vés a la infermeria i digues que no et trobes bé.',
        scared: 'Però i si s’enfada? I si dic alguna cosa malament?',
        brave: 'Dir «no ho sé» és de valents. Als mestres els agraden les preguntes.',
        withYou: 'T’acompanyo. No estaràs sola.',
        braveReply: 'Valenta… d’acord. Puc ser valenta.',
        withYouReply: 'De veritat? Gràcies… així és més fàcil.',
        phraseIntro: 'Podries dir-ho així, en anglès, per practicar:',
        teacher: 'Gràcies per dir-m’ho, Xiaomei. No entendre una cosa és com comença l’aprenentatge. Mirem juntes l’exercici 3 a l’esbarjo.',
        thanks: 'No s’ha enfadat gens! M’alegro d’haver preguntat. Gràcies per ser el meu amic.',
        copyEnd: 'La Xiaomei copia les teves respostes. A classe, la senyora Lin li demana que expliqui l’exercici 3… i no pot. Et mira en silenci. Copiar no l’ha ajudat a aprendre.',
        sickEnd: 'La infermera revisa la Xiaomei amb molta cura i li diu que no està malalta. La Xiaomei es perd la classe i continua sense entendre l’exercici 3.',
      },
      standing: {
        open: 'Pst! La senyora Lin m’ha fet quedar dret al fons perquè no parava de parlar. Quina injustícia! Ei, vols veure la meva cara divertida? 😜',
        good: 'Ara no. No ens fiquem en més embolics. M’ho expliques a l’esbarjo!',
        clown: 'Fer-li ganyotes tu també.',
        mock: 'T’ho mereixes.',
        why: '…Sí, d’acord. No ho faig expressament. És que m’emociono i les paraules se m’escapen!',
        tipWrite: 'Quan se t’acudeixi alguna cosa, apunta-la i m’ho expliques després.',
        tipBreathe: 'Respira fondo i aixeca la mà. Espera el teu torn.',
        tipReply: 'Vaja. Això podria funcionar. Com una llibreta secreta d’acudits!',
        fix: 'Hauria de dir alguna cosa a la senyora Lin?',
        fixGood: 'Sí. Demana-li perdó i explica-li el teu pla.',
        fixLater: 'Potser esperar que se n’oblidi.',
        fixLaterReply: 'Mmm… crec que no se n’oblidarà. És millor arreglar-ho. Som-hi.',
        phraseIntro: 'Diguem-ho junts, en anglès:',
        teacher: 'Gràcies, Azhe. Veig que t’hi estàs esforçant de veritat. Seu, i m’encantarà sentir les teves idees quan et toqui.',
        thanks: 'Sííí! Autocontrol: nivell u! Gràcies, company.',
        clownEnd: 'La senyora Lin es gira i us veu tots dos fent ganyotes. «Ara sou dos?», diu amb calma. Us quedeu drets fins que sona el timbre. Ja no fa tanta gràcia.',
        mockEnd: 'L’Azhe deixa de somriure. «Vaja. Moltes gràcies», murmura, i aparta la mirada.',
      },
      ball: {
        open: '—És LA MEVA pilota! L’he portada jo! —crida en Xiaoqiang.\n—Però l’has tinguda TOT l’esbarjo! Em toca a mi! —crida la Xiaofang.',
        calm: 'Ei, calmem-nos. Podeu dir cadascú com us sentiu?',
        sideQiang: '«En Xiaoqiang té raó. És la seva pilota.»',
        sideFang: '«La Xiaofang té raó. Compartiu!»',
        grab: 'Agafar la pilota i fugir corrents!',
        iIntro: 'Prova de dir-ho així: «Em sento… quan… perquè…». Quin és un missatge en primera persona?',
        iGood: '«Em sento trista quan no em toca, perquè jo també vull jugar.»',
        iBad1: '«Ets SUPEREGOISTA!»',
        iBad2: '«Sempre ho espatlles tot!»',
        iBadReply: 'Aquesta frase culpa l’altra persona i provoca una baralla més grossa. Un missatge en primera persona parla del que sents TU.',
        iReply: 'La Xiaofang respira fondo i ho diu. En Xiaoqiang parpelleja. «Ah… no sabia que et senties trista.»',
        phraseIntro: 'Aquí tens aquest missatge en anglès; digues-lo amb ella:',
        solve: 'Llavors… què fem ara?',
        turns: 'Feu torns: cinc minuts cadascú.',
        together: 'Jugueu junts! Passeu-vos la pilota.',
        solveReply: '«D’acord… perdó per cridar», diu en Xiaoqiang. «Perdó jo també», diu la Xiaofang. «Juguem junts?»',
        thanks: 'Gràcies per ajudar-nos. Ha estat millor que barallar-nos!',
        sideQiangEnd: 'En Xiaoqiang somriu i se’n va corrents amb la pilota. A la Xiaofang se li omplen els ulls de llàgrimes. «Molt bé. Tant me fa.» Se’n va sola.',
        sideFangEnd: 'En Xiaoqiang llença la pilota a terra. «Doncs queda-te-la! Esteu tots contra mi!» Se’n va picant de peus.',
        grabEnd: 'Fuges corrents amb la pilota. Ningú no riu. Ara en Xiaoqiang i la Xiaofang estan enfadats entre ells I amb tu.',
      },
    },

    events: {
      forgotHomework: {
        ask: 'Bon dia a tothom. Si us plau, entregueu els deures de la setmana passada… Oh? No tens els teus?',
        honest: 'Ho sento, me’ls he descuidat.',
        excuse: 'Se’ls ha menjat el meu gos!',
        honestReply: 'Gràcies per ser sincer. Això és el més important. Pots fer-los a l’esbarjo o portar-los la propera vegada.',
        excuseReply: 'Mmm. M’estimo més sentir la veritat; no m’enfadaré. Te’ls has descuidat?',
        admit: 'Sí… me’ls he descuidat. Perdó.',
        admitReply: 'Gràcies. Ho veus? La veritat pesa menys.',
        makeUp: '📝 Fer-los ara a l’esbarjo',
        later: 'Portar-los la propera vegada',
        doneReply: 'Molt bé! Gràcies per arreglar-ho.',
      },
      lostPencil: {
        start: '😟 Oh, no! El teu estoig no és a la motxilla. I si mires a la caixa d’objectes perduts del passadís?',
        found: 'Aquí és: el teu estoig, amb el teu nom a l’etiqueta! Algú amable l’haurà entregat.',
        idle: 'Una caixa de coses perdudes: un guant solitari, una ampolla d’aigua, tres gomes d’esborrar…',
        other: (what: string, who: string) => `Hi ha ${what} amb un nom: «${who}».`,
        give: (who: string) => `Portar-ho a ${who}`,
        leave: 'Deixar-ho',
        thanks: 'El que havia perdut! Moltíssimes gràcies per portar-me-ho!',
        items: { eraser: 'una goma de dinosaure', bottle: 'una ampolla d’aigua blava', ruler: 'un regle brillant', bookmark: 'un punt de llibre de gat', keychain: 'un clauer d’osset' },
        carrying: (what: string, who: string) => `Portes ${what} per a ${who}.`,
      },
      misunderstanding: {
        ask: 'Algú ha vessat l’aigua de les pintures a l’aula de plàstica i ho ha deixat així. Has estat tu? Estic decebuda.',
        calm: 'Mantenir la calma i explicar-ho.',
        shout: 'És SUPERINJUST! Sempre em culpes a mi!',
        silent: 'No dir res i enfurrunyar-se.',
        explain: 'A aquella hora jo era a la biblioteca, no a l’aula de plàstica. Però puc ajudar a netejar-ho.',
        calmReply: 'Oh… tens raó, la bibliotecària et va veure. Em sap greu haver tret conclusions tan de pressa. Gràcies per explicar-ho amb tanta calma, i per oferir-te a ajudar.',
        shoutReply: 'Entenc que estiguis disgustat. Però si crides em costa escoltar-te. M’ho pots explicar amb calma?',
        silentReply: 'No puc saber què ha passat si no m’ho expliques. Respira fondo; t’escolto.',
        tryCalm: 'Respirar fondo i explicar-ho amb calma.',
      },
      bullying: {
        start: '😢 Sents algú plorar a prop de l’arbre dels estels, al parc…',
        open: 'Dos nens grans es riuen de l’estel d’en Bo. «Estel de nadó! Estel de nadó!» En Bo intenta no plorar.',
        stand: 'Posar-te al costat d’en Bo i dir amb calma: «Pareu, si us plau. Això no està bé.»',
        tell: 'Anar a avisar un adult (l’oncle Chun o la mare d’en Bo).',
        fight: 'Empènyer-los!',
        ignore: 'Marxar i fer veure que no ho has vist.',
        fightReply: 'Barallar-se ho empitjora tot: algú podria fer-se mal i llavors TU també et ficaries en un embolic. Hi ha una manera més valenta.',
        standReply: 'Els grans es queden sorpresos. «Bah, és igual», murmuren, i se’n van. En Bo s’eixuga els ulls. «T’has… quedat. Gràcies.»',
        tellReply: 'Un adult s’hi acosta i parla en veu baixa amb els grans. Demanen perdó a en Bo. Avisar no és ser un xivato: és demanar ajuda.',
        ignoreReply: 'Te’n vas. Darrere teu, les rialles continuen. Tota la tarda notes un pes a la panxa.',
        boThanks: 'Ets un amic de veritat. Vols fer volar el meu estel amb mi?',
      },
      contest: {
        notice: '🐝 Concurs de lletrejar de la classe a les 2 de la tarda! Vine al tauler d’anuncis per apuntar-t’hi.',
        intro: 'Benvinguts al concurs de lletrejar de la classe! Tres paraules. Escolteu bé i trieu com s’escriu.',
        join: '🐝 Apuntar-se al concurs de lletrejar',
        notYet: 'El concurs de lletrejar comença a les 2 de la tarda.',
        over: 'El concurs de lletrejar ja s’ha acabat per avui.',
        word: (n: number) => `Paraula ${n} de 3. Escolta… 🔊`,
        hear: '🔊 Tornar a escoltar',
        right: '✅ Correcte!',
        wrong: (w: string) => `❌ Ui! S’escriu «${w}».`,
        win: '🏅 Has guanyat el concurs de lletrejar! La senyora Lin et posa una abella daurada a la samarreta. Tothom aplaudeix!',
        setback: 'Aquesta vegada has quedat quart. La teva amiga Xiaomei ha guanyat amb «necessary».',
        mindsetQ: 'Senyora Lin: «Com et sents?»',
        mindsetGood: 'Practicaré i ho tornaré a intentar la propera vegada!',
        mindsetBad: 'És que soc un desastre lletrejant.',
        mindsetBadReply: 'No ets un desastre lletrejant: és que ENCARA no se’t dona bé. Tots els experts van ser principiants alguna vegada. Què podries provar la propera vegada?',
        mindsetReply: 'Així m’agrada! Practicar una mica cada dia funciona de veritat.',
        winReply: 'Enhorabona! Recorda: has arribat aquí practicant. Continua així!',
        /** PRÀCTICA D’ANGLÈS: paraules per lletrejar; es queden en anglès. */
        words: ['because', 'friend', 'beautiful', 'library', 'Wednesday', 'different', 'tomorrow', 'favourite', 'believe', 'together', 'surprise', 'answer'],
      },
      quiz: {
        start: 'Hora de l’examen sorpresa! No us preocupeu: només és per veure què hem après. Feu-ho tan bé com pugueu!',
        go: '📝 Començar l’examen',
        result: (g: string) => (g === 'A' ? 'Excel·lent feina! Una A!' : g === 'B' ? 'Bona feina, una B! Amb una mica més de pràctica, volaràs.' : 'Aquesta vegada una C. Això només ens diu què hem de practicar. Ho aconseguirem junts.'),
      },
      parentsMeeting: {
        notice: '👨‍👩‍👧 Aquest vespre hi ha reunió de pares! La mama veurà la senyora Lin després de classe.',
        momIntro: 'Ja he tornat de la reunió de pares (家長會). La senyora Lin m’ho ha explicat tot de tu…',
        great: 'M’ha dit que ets amable i que ajudes els teus companys. M’ha explicat aquests moments:',
        proud: 'Estic molt orgullosa de tu!',
        study: 'També m’ha dit que t’esforces molt en els estudis. Continua així!',
        studyLow: 'M’ha dit que podries concentrar-te una mica més a estudiar. Fem un pla junts?',
        unkind: 'M’ha comentat que una vegada no vas ser gaire amable amb un company. Com creus que es va sentir?',
        reflect: 'Segurament es va sentir trist. Li demanaré perdó.',
        reflectReply: 'Aquest és el meu nen. Demanar perdó és de valents.',
        thanksMom: 'Gràcies, mama! ❤️',
        plan: 'Fem un pla d’estudi junts.',
        planReply: 'Molt bé. Vint minuts cada vespre, i jo preparo el te. Tracte fet?',
        nothing: 'M’ha dit que ets un nen encantador, i que li encantaria veure més del que saps fer!',
        done: 'La mama et fa una abraçada enorme.',
      },
    },
  },
};
